export enum EmployeeSignUpSteps {
  ACCEPT_INVITATION = "ACCEPT_INVITATION",
  SET_PASSWORD = "SET_PASSWORD",
}
